// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tn-toast-host {
  position: fixed;
  bottom: max(16px, env(safe-area-inset-bottom));
  right: max(16px, env(safe-area-inset-right));
  z-index: 11000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: min(360px, calc(100vw - 32px));
  pointer-events: none;
}

.tn-toast {
  pointer-events: auto;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #0a1628;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 12px 14px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 13px;
  line-height: 1.45;
  animation: tn-toast-rise 0.22s ease-out;
}

@keyframes tn-toast-rise {
  from { transform: translateY(12px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

.tn-toast__msg { flex: 1 1; }

.tn-toast__close {
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.65);
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
  flex-shrink: 0;
}

.tn-toast__close:hover { color: #fff; }

.tn-toast--success { border-left: 3px solid #10b981; }
.tn-toast--error   { border-left: 3px solid #ef4444; }
.tn-toast--info    { border-left: 3px solid #00a896; }

@media (prefers-reduced-motion: reduce) {
  .tn-toast { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Toast/Toast.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,8CAA8C;EAC9C,4CAA4C;EAC5C,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,+EAA+E;EAC/E,eAAe;EACf,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA,iBAAiB,SAAO,EAAE;;AAE1B;EACE,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,yBAAyB,WAAW,EAAE;;AAEtC,qBAAqB,8BAA8B,EAAE;AACrD,qBAAqB,8BAA8B,EAAE;AACrD,qBAAqB,8BAA8B,EAAE;;AAErD;EACE,YAAY,eAAe,EAAE;AAC/B","sourcesContent":[".tn-toast-host {\n  position: fixed;\n  bottom: max(16px, env(safe-area-inset-bottom));\n  right: max(16px, env(safe-area-inset-right));\n  z-index: 11000;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: min(360px, calc(100vw - 32px));\n  pointer-events: none;\n}\n\n.tn-toast {\n  pointer-events: auto;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: #0a1628;\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 12px 14px;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-size: 13px;\n  line-height: 1.45;\n  animation: tn-toast-rise 0.22s ease-out;\n}\n\n@keyframes tn-toast-rise {\n  from { transform: translateY(12px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}\n\n.tn-toast__msg { flex: 1; }\n\n.tn-toast__close {\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 4px;\n  flex-shrink: 0;\n}\n\n.tn-toast__close:hover { color: #fff; }\n\n.tn-toast--success { border-left: 3px solid #10b981; }\n.tn-toast--error   { border-left: 3px solid #ef4444; }\n.tn-toast--info    { border-left: 3px solid #00a896; }\n\n@media (prefers-reduced-motion: reduce) {\n  .tn-toast { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
